// src/components/Contact.js
import React from 'react';

const Contact = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Contact Us</h1>
      <p>We’d love to hear from you!</p>
      <p>Feel free to reach out with any questions, feedback, or support needs.</p>

      <h3>Customer Support</h3>
      <p>Email: support@ecomm.com</p>
      <p>Phone: +91-9987075416</p>

      <h3>Business Inquiries</h3>
      <p>Email: business@ecomm.com</p>

      <h3>Address</h3>
      <p>
        E-comm Electronics Pvt. Ltd. <br />
        123 Tech Street, Mumbai, India <br />
        PIN: 560001
      </p>
    </div>
  );
};

export default Contact;
